<div class="zone-drawer-container">
    <div class="map-controls" *ngIf="!readonly && !isViewMode">
      <button 
        mat-raised-button 
        color="primary" 
        (click)="enablePolygonDrawing()"
        [disabled]="hasActiveDrawing"
        class="control-btn">
        <mat-icon>crop_free</mat-icon>
        Draw Polygon
      </button>
      
      <button 
        mat-raised-button 
        color="primary" 
        (click)="enableCircleDrawing()"
        [disabled]="hasActiveDrawing"
        class="control-btn">
        <mat-icon>radio_button_unchecked</mat-icon>
        Draw Circle
      </button>
      
      <button 
        mat-raised-button 
        color="warn" 
        (click)="clearDrawing()"
        [disabled]="!hasActiveDrawing"
        class="control-btn">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
    
    <div 
      [id]="mapId" 
      class="zone-map"
      [style.height]="mapHeight">
    </div>
    
    <div class="zone-info" *ngIf="currentZoneData && showPolygonInfo">
      <mat-card class="info-card">
        <mat-card-header>
          <mat-card-title>Zone Information</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="info-row">
            <strong>Type:</strong> {{ currentZoneData.type | titlecase }}
          </div>
          <div class="info-row">
            <strong>Centroid:</strong> 
            {{ formatCoordinate(currentZoneData.centroid) }}
          </div>
          <div class="info-row" *ngIf="currentZoneData.type === 'Circle'">
            <strong>Radius:</strong> {{ formatRadius(currentZoneData.radius!) }}
          </div>
          <div class="info-row" *ngIf="currentZoneData.type === 'Polygon'">
            <strong>Points:</strong> {{ currentZoneData.coordinates?.length }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>